module.exports = __webpack_public_path__ + "static/media/punch.4497882c.mp3";